export default __webpack_public_path__ + "static/media/website-08 2.7d59f548.png";